<template>
    <div id="filter_advanced">
        <div class="ui form" @keypress.enter="$parent.$parent.distributions_filter()">
            <div class="three fields">
                <div class="field">
                    <label>{{ $t('models.attributes.distributions.name') }}</label>
                    <input type="text"
                        v-model="filter.columns.name"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.distributions.strategy_value') }}</label>
                    <input type="text"
                        v-model="filter.columns.strategy_value"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.distributions.strategy') }}</label>
                    <div class="ui selection fluid dropdown" v-dropdown>
                        <div class="text"
                            v-for="strategy in strategies"
                            v-if="filter.columns.strategy == strategy.value">
                            {{ strategy.name }}
                        </div>
                        <i class="dropdown icon"></i>
                        <div class="menu">
                            <div
                                v-for="strategy in strategies"
                                @click="filter.columns.strategy = strategy.value"
                                class="item"
                                :class="{
                                    'selected active': filter.columns.strategy == strategy.value
                                }">
                                {{ strategy.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="four fields">
                <div class="field">
                    <label>{{ $t('models.attributes.distributions.priority') }}</label>
                    <input type="text"
                        v-model="filter.columns.priority"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.distributions.station_identity') }}</label>
                    <div class="ui selection fluid dropdown" v-dropdown>
                        <div class="text"
                            v-for="station in stations"
                            v-if="filter.columns.station_identity == station.identity">
                            {{ station.name }}
                        </div>
                        <i class="dropdown icon"></i>
                        <div class="menu">
                            <div
                                v-for="station in stations"
                                @click="filter.columns.station_identity = station.identity"
                                class="item"
                                :class="{
                                    'selected active': filter.columns.station_identity == station.identity
                                }">
                                {{ station.name }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.distributions.material_identity') }}</label>
                    <div class="ui selection fluid dropdown" v-dropdown>
                        <div class="text"
                            v-for="material in materials"
                            v-if="filter.columns.material_identity == material.identity">
                            {{ material.name }}
                        </div>
                        <i class="dropdown icon"></i>
                        <div class="menu">
                            <div
                                v-for="material in materials"
                                @click="filter.columns.material_identity = material.identity"
                                class="item"
                                :class="{
                                    'selected active': filter.columns.material_identity == material.identity
                                }">
                                {{ material.name }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.distributions.is_activated') }}</label>
                    <div class="ui checkbox" v-checkbox>
                        <input type="checkbox" v-model="filter.columns.is_activated">
                        <label>{{ $t('ui.general.yes') }}</label>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="ui icon blue button right floated"
            @click="$parent.$parent.distributions_filter()">
            <i class="search icon"></i>
            {{ $t('ui.general.search') }}
        </div>
        <div class="clear">

        </div>
    </div>
</template>

<script>

export default {
    name: "DistributionsFilterAdvanced",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.distributions_module
        },
        filter() {
            return this.current_store.filter
        },
        stations() {
            return [{
                name: this.$t('ui.general.please_select'),
                identity: null,
            }].concat(this.$store.state.provider.stations)
        },
        materials() {
            return [{
                name: this.$t('ui.general.please_select'),
                identity: null,
            }].concat(this.$store.state.provider.distributions_module.materials)
        },
        strategies() {
            return [
                {name: this.$t('ui.general.please_select'), value: null},
                // 站點直派
                {name: this.$t('ui.pages.distributions.filter.direct'), value: "direct"},
                // 轉聯運
                {name: this.$t('ui.pages.distributions.filter.intermodal'), value: "intermodal"},
            ]
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
    }
}
</script>

<style>
.el-date-editor.el-range-editor input {
    border: none !important;
}
</style>
<style scoped lang="scss">

</style>
